<template>
  <v-container>
    <p
      class="listTotalHeader"
      v-if="this.totalBlocksInDB && this.totalBlocksInDB > 0"
    >
      {{ `${this.totalBlocksInDB} Blocks found (showing the last 2000 Records)` }}
    </p>
    <Loader v-if="isLoading" />
    <Empty v-else-if="blocks && (blocks.length == 0 || totalBlocks == 0)"/>
    <b-table
      v-else-if="!isLoading"
      :data="blocks"
      class="table"
	  v-bind:mobileCards="false"
    >

      <template slot-scope="props">
          <b-table-column field="block_meta.header.height" label="Number">
            <router-link
              class="router-link"
              :to="{ name: 'block', params: {blockNumber: props.row.block_meta.header.height}}"
            >
              {{ props.row.block_meta.header.height }}
            </router-link>
          </b-table-column>

          <b-table-column field="txns" label="Txns">
            <router-link
              v-if="props.row.block_meta.header.num_txs > 0"
              class="router-link"
              :to="{ name: 'blockTransactions', params: {blockNumber: props.row.block_meta.header.height}}"
            >
              <p>{{ `${props.row.block_meta.header.num_txs} ${props.row.block_meta.header.num_txs !== 1 ? "txns" :  "txn"}` }}</p>
            </router-link>
            <div v-else-if="props.row.block_meta.header.num_txs <= 0">
              <p>
                {{ `${props.row.block_meta.header.num_txs} ${props.row.block_meta.header.num_txs !== 1 ? "txns" :  "txn"}` }}
              </p>
            </div>
          </b-table-column>

          <b-table-column field="timeStamp" label="Time">
            <v-tooltip bottom>
              <span slot="activator">
                <timeago :datetime="props.row.block_meta.header.time" :auto-update="10">
                </timeago>
              </span>
              <span>{{ new Date(props.row.block_meta.header.time).toISOString() }}</span>
            </v-tooltip>
          </b-table-column>

          <b-table-column field="hash" label="Hash">
            <p class="short-addr" v-if="props.row.blockEth">
              {{ `${props.row.blockEth && props.row.blockEth.hash ? props.row.blockEth.hash : props.row.block_meta.block_id.hash }` }}
            </p>
            <p v-else>
              --
            </p>
          </b-table-column>

          <b-table-column
            field="blockReward"
            label="Block Award"
          >
            <p v-if="props.row.rewards_total >= 0">
              {{ `${Number.parseFloat(props.row.rewards_total).toFixed(5)} CMT` }}
            </p>
          </b-table-column>

          <b-table-column field="gasUsed" label="Gas Used">
            {{ props.row.blockEth && props.row.blockEth.gasUsed >= 0 ? props.row.blockEth.gasUsed : '' }}
          </b-table-column>

          <!-- <b-table-column label="Gas Used">
            {{ props.row.gasUsed }}
          </b-table-column>
          <b-table-column field="size" label="Bytes">
              {{ props.row.size }} Bytes
          </b-table-column> -->

      </template>
  </b-table>
  <el-pagination
    background
    @current-change="shift"
    @prev-click="shift(currentPage-1)"
    @next-click="shift(currentPage+1)"
    layout="prev, pager, next"
    :current-page="currentPage"
    :pager-count=5
    :page-size="pageSize"
    :total="totalBlocks">
  </el-pagination>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '../reusables/loader.vue';
import Empty from '../reusables/empty.vue';

export default {
  name: 'Blocks',
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      isLoading: false,
    };
  },
  components: {
    Loader,
    Empty,
  },
  watch: {
    blocks() {
      this.isLoading = false;
    },
    '$route.query.page': function (newPage) {
      this.initData(newPage);
    },
  },
  methods: {
    initData(page) {
      if (!isNaN(page)) {
        const pageQuery = parseInt(page);
        this.currentPage = pageQuery;
        this.isLoading = true;
        this.$store.dispatch('fetchBlocks', {
          limit: this.pageSize,
          page: pageQuery,
        });
      }
    },
    shift(page) {
      this.$router.push({ path: this.$route.path, query: { page } });
    },
    appendQueries() {
      const pageQuery = parseInt(this.$route.query.page);
      this.currentPage = pageQuery;
      this.$router.push({
        path: this.$route.path,
        query: { page: pageQuery || 1 },
      });
      this.initData(pageQuery);
    },
  },
  computed: {
    ...mapGetters(['blocks', 'totalBlocks', 'totalBlocksInDB', 'fetchError']),
  },
  created() {
    this.appendQueries();
  },
};
</script>

<style lang="scss">
</style>
